
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ColorQualityMappingDialog extends _Ext.DialogBase<ColorQualityMappingRow, any> {
        protected getFormKey() { return ColorQualityMappingForm.formKey; }
        protected getIdProperty() { return ColorQualityMappingRow.idProperty; }
        protected getLocalTextPrefix() { return ColorQualityMappingRow.localTextPrefix; }
        protected getService() { return ColorQualityMappingService.baseUrl; }
        protected getDeletePermission() { return ColorQualityMappingRow.deletePermission; }
        protected getInsertPermission() { return ColorQualityMappingRow.insertPermission; }
        protected getUpdatePermission() { return ColorQualityMappingRow.updatePermission; }
        protected useViewMode() { return true; }

        protected get_ExtDialogOptions() {
            let options = super.get_ExtDialogOptions();
            options.ShowSaveAndNewButtonInToolbar = true;
            options.AutoFitContentArea = false;
            return options;
        }
        protected form = new ColorQualityMappingForm(this.idPrefix);

    }
}